import React, { Component } from 'react';
import { Container, TableContainer, Typography, Grid } from '@material-ui/core';

import './spk.css';

class SuratPerintahKerja extends Component {
    render() {
        return (
            <Container>
                <div className="border-main-spk">
                    <img src="/image/logo-eduprime.png" width="20%"/>
                    <table width="100%" border="1">
                        <tbody>

                            {/* Row 1 */}
                            <tr>
                                <td rowSpan="2" width="35%">
                                    <Typography variant="body1" color="textPrimary">Surat Perintah Kerja SPK</Typography>
                                </td>
                                <td colSpan="4">
                                    <Typography variant="body1" color="textPrimary">Nama Satuan Pendidikan : SMK NEGERI 13 SURABAYA</Typography>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="4">
                                    <Typography variant="body1" color="textPrimary">Nomor SPK : S10001902057</Typography>
                                </td>
                            </tr>

                            {/* Row 2 */}
                            <tr>
                                <td rowSpan="4">
                                    Paket Pekerjaan:Kegiatan jual beli melalui mitra SIPLah Blibli.com
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="4">
                                    <Typography variant="body1" color="textPrimary">
                                        Tanggal SPK : 19/11/21
                                    </Typography>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="4">
                                    <Typography variant="body1" color="textPrimary">
                                        Tanggal Negosiasi : 19/11/21
                                    </Typography>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="4">
                                    <Typography variant="body1" color="textPrimary">
                                        SPK ini mulai berlaku efektif terhitung sejak tanggal ditetapkan dan penyelesaiankeseluruhan pekerjaan sebagaimana dimaksud dalam SPK ini.
                                    </Typography>
                                </td>
                            </tr>

                            {/* Row 3 */}
                            <tr>
                                <td colSpan="5">
                                    <Typography variant="body1" color="textPrimary">
                                        Waktu Pelaksanaan Pekerjaan : 19/11/21
                                    </Typography>
                                    <Typography variant="body1" color="textPrimary">
                                        Waktu Pemrosesan Pekerjaan : 26/11/21
                                    </Typography>
                                    <Typography variant="body1" color="textPrimary">
                                        Waktu Penyelesaian Pekerjaan : 01/12/21
                                    </Typography>
                                </td>
                            </tr>

                            {/* Row 4 */}
                            <tr>
                                <td colSpan="5">
                                    <Typography variant="body1" color="textPrimary">
                                        Penyetoran Pajak : Disetor oleh Satdik
                                    </Typography>
                                </td>
                            </tr>

                            {/* Row 5 */}
                            <tr align="center">
                                <td colSpan="5">
                                    <Typography variant="body1" color="textPrimary">
                                        Rincian Pekerjaan
                                    </Typography>
                                </td>
                            </tr>

                            {/* Row 6 / Detail Pembelian */}
                            <tr>
                                <td>Uraian Barang / Jasa</td>
                                <td>Jumlah (QTY)</td>
                                <td>Satuan Ukuran</td>
                                <td>Harga Satuan</td>
                                <td>Total Harga</td>
                            </tr>


                            <tr>
                                <td>1</td>
                                <td>2</td>
                                <td>3</td>
                                <td>4</td>
                                <td>5</td>
                            </tr>

                            {/* Row 7 Total Harga */}
                            <tr>
                                <td colSpan="4" className="detail-total-harga">
                                    Subtotal (Rp) <br />
                                    Total sebelum PPN (Rp) <br />
                                    PPN (Rp) <br />
                                    Biaya Kirim (Rp) <br />
                                    Asusransi (Rp) <br />
                                    Total Pembayaran (Rp)
                                </td>
                                <td className="detail-total-harga">
                                    Rp. 23 <br />
                                    - <br />
                                    - <br />
                                    - <br />
                                    - <br />
                                    -
                                </td>
                            </tr>

                            {/* Row 8 Angka Terbilang */}
                            <tr>
                                <td colSpan="5">
                                    Terbilang : Delapan belas juta dua ratus lima puluh ribu rupiah
                                </td>
                            </tr>

                            {/* Row 9 INSTRUKSI KE PENYEDIA */}
                            <tr>
                                <td colSpan="5">
                                    <Grid container spacing={6}>
                                        <Grid item xs={12}>
                                            INSTRUKSI KE PENYEDIA : <br />
                                            Penagihan hanya dapat dilakukan setelah penyelesaian pekerjaan yang diperintahkan dalam SPK ini dan dibuktikan dengan Berita AcaraSerah Terima
                                        </Grid>

                                        <Grid item xs={6} align="center">
                                            <br />
                                            Penyedia
                                            <br /><br /><br /><br /><br /><br />
                                            Deasy Nadha Helmina<br />
                                            Eduprime
                                        </Grid>
                                        <Grid item xs={6} align="center">
                                            Kota Surabaya, Sabtu 22 Januari 2022
                                            <br />
                                            Penyedia
                                            <br /><br /><br /><br /><br /><br />
                                            Heru Mursanyoto<br />
                                            NIP: 196309131987031016
                                        </Grid>

                                    </Grid>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </Container>
        );
    }
}

export default SuratPerintahKerja;